<template>
  <div>
    <p v-if="isLoadedNormal">
      Количество игроков, у которых заблокирован доступ к событиям: {{playerAmountWithBlockedEventAccess | getFormattedNumber}}
    </p>

    <loading-indicator v-if="isLoading"/>
  </div>
</template>

<script>
import notifier from '../notifier.js';
import { HTTP } from '../http-common.js';

import LoadingIndicator from './LoadingIndicator.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'PlayersEventAccessBlocking',

  components: {
    LoadingIndicator,
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,

      /** @type {?number} */
      playerAmountWithBlockedEventAccess: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },
  },

  created() {
    this.loadStat();
  },

  methods: {
    // Метод загружает количество игроков,
    // у которых заблокирован доступ к событиям.
    loadStat() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const url = `/player_amount_with_blocked_event_access`;
      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        this.playerAmountWithBlockedEventAccess = data;

        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },
}
</script>
